import React from 'react';

const UnauthorizedSection = () => {
  return (
    <section className="hero is-warning is-bold mt-6">
      <div className="hero-body">
        <div className="container">
          <h1 className="title">
            Error
          </h1>
          <h2 className="subtitle">
            No tiene permiso para ver esta pagina/orden, por favor contáctese con el administrador
          </h2>
        </div>
      </div>
    </section>
  )
}

export default UnauthorizedSection;